import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';


import { NotificationInterface, NotificationData } from '@core/store/models/notifications.interface';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import * as fromState from '@core/store/state/notifications/notifications.state';
import * as fromActions from '@core/store/state/notifications/notifications.actions';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(private store: Store<fromState.Notifications>, private actions$: Actions) {}

    /**
     * 
     * @returns the list of notifications on the store
     */
    getNotifications = ():  Observable<NotificationInterface[]> => this.store.select(fromState.itemsSelector);
    
    /**
     * 
     * @param id the identifier of the notification to hide/delete
     * @returns void
     */
    dismissNotification = (id: string) => this.store.dispatch( new fromActions.Hide(id));

    addNotification = ( context: NotificationsContextEnum , data: NotificationData) => this.store.dispatch( new fromActions.Add(context, data))

    clearNotifications = () => this.store.dispatch(new fromActions.Clear());

}
